/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Einvoice_Auto_SentInputs */

const vi_pos_einvoice_auto_sent = /** @type {(inputs: Pos_Einvoice_Auto_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang phát hành hóa đơn: hệ thống đã tự gửi lên MISA, đang chờ MISA ký và cấp số.`)
};

/**

* @param {Pos_Einvoice_Auto_SentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_einvoice_auto_sent = /** @type {((inputs?: Pos_Einvoice_Auto_SentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Einvoice_Auto_SentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_einvoice_auto_sent(inputs)
});